import React from 'react';
import { PropTypes } from 'prop-types';
import MemberRecognitionBlock from './MemberRecognitionBlock';
import colors from '@general/colors';
import useMemberFull from '@hooks/useMemberFull';

const borderColors = [colors.brightSun, colors.emerald, colors.black, colors.aqua, colors.cinnebar];

const MemberRecognitionList = ({ graphID }) => {
    const { data } = useMemberFull(graphID);

    if (!data || data.recognition.length === 0) return null;

    return (
        <div className="row">
            {data.recognition.map((recognition, index) => (
                <div className="d-flex flex-column mb-4 col-md-3" key={`recognition-${data.id}-${index}`}>
                    <MemberRecognitionBlock
                        recognitionString={recognition}
                        borderColor={
                            borderColors[index] ? borderColors[index] : borderColors[index % borderColors.length]
                        }
                    />
                </div>
            ))}
        </div>
    );
};

MemberRecognitionList.propTypes = {
    graphID: PropTypes.string,
};

export default MemberRecognitionList;
